import API from "./urls";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import IHttpRequest from "src/http/http-request";

/**
 * 发送ajax请求
 * @param {any} options 请求参数
 * @param {string} url 请求地址
 * @param {string} method 请求类型
 * @returns {any}
 */
const send = (url: string, options?: IHttpRequest, method: string = "post"): IHttpResponse => {
  // 如果未传入url以及参数抛出异常
  if (!url) {
    throw new Error("url is null.");
  }

  // 返回promise实例由用户处理
  return HttpClient.instance[method]({
    url,
    ...options,
  });
};

/**
 * 接口类
 * @version 1.0.0
 */
export default class Apis {
  // 以下为团检接口
  public jump2Personal = (option?: IHttpRequest) => send(API.jump2Personal, option);
  public queryNotSumbitAnalyzeReport = (option?: IHttpRequest) => send(API.queryNotSumbitAnalyzeReport, option);
  public login = (option?: IHttpRequest) => send(API.login, option);
  public smsLogin = (option?: IHttpRequest) => send(API.smsLogin, option);
  public uploadFile = (option?: IHttpRequest) => send(API.uploadFile, option);
  public delFile = (option?: IHttpRequest) => send(API.delFile, option);
  public getOrgInfo = (option?: IHttpRequest) => send(API.getOrgInfo, option, "get");
  public getMedicalpackage = (option?: IHttpRequest) => send(API.getMedicalpackage, option, "get");
  public getPackageInfo = (option?: IHttpRequest) => send(API.getPackageInfo, option);
  public getWechatJSSDK = (option?: IHttpRequest) => send(API.getWechatJSSDK, option, "get");
  public getHospitalList = (option?: IHttpRequest) => send(API.getHospitalList, option);
  public getNearestHospitalList = (option?: IHttpRequest) => send(API.getNearestHospitalList, option);
  public getOptionalPackageInfo = (option?: IHttpRequest) => send(API.getOptionalPackageInfo, option);
  public locationCity = (option?: IHttpRequest) => send(API.locationCity, option, "get");
  public getRegion = (option?: IHttpRequest) => send(API.getRegion, option, "get");
  public getMedicalOrgDateInfo = (option?: IHttpRequest) => send(API.getMedicalOrgDateInfo, option);
  public submitOrder = (option?: IHttpRequest) => send(API.submitOrder, option);
  public smsSend = (option?: IHttpRequest) => send(API.smsSend, option);
  public getFamilyList = (option?: IHttpRequest) => send(API.getFamilyList, option, "get");
  public getFamilyDetail = (option?: IHttpRequest) => send(API.getFamilyDetail, option, "get");
  public updateFamily = (option?: IHttpRequest) => send(API.updateFamily, option, "put");
  public addFamily = (option?: IHttpRequest) => send(API.addFamily, option);
  public wechatOauth = (option?: IHttpRequest) => send(API.wechatOauth, option);
  public forgetPassword = (option?: IHttpRequest) => send(API.forgetPassword, option);
  public updatePwd = (option?: IHttpRequest) => send(API.updatePwd, option);
  public getOrderList = (option?: IHttpRequest) => send(API.getOrderList, option);
  public getOrderQuantity = (option?: IHttpRequest) => send(API.getOrderQuantity, option);
  public getOrderDetail = (option?: IHttpRequest) => send(API.getOrderDetail, option, "get");
  public proceedPay = (option?: IHttpRequest) => send(API.proceedPay, option, "get");
  public cancelOrder = (option?: IHttpRequest) => send(API.cancelOrder, option, "put");
  public modifiedOrderDate = (option?: IHttpRequest) => send(API.modifiedOrderDate, option);

  // 意见反馈
  public getFeedbackList = (option?: IHttpRequest) => send(API.getFeedbackList, option);
  public addFeedback = (option?: IHttpRequest) => send(API.addFeedback, option);
  public updateFeedback = (option?: IHttpRequest) => send(API.updateFeedback, option);
  public getFeedbackDetail = (option?: IHttpRequest) => send(API.getFeedbackDetail, option, "get");
  public getUnReadMessage = (option?: IHttpRequest) => send(API.getUnReadMessage, option, "get");
  public uploadAvatar = (option?: IHttpRequest) => send(API.uploadAvatar, option);
  public modifyPhone = (option?: IHttpRequest) => send(API.modifyPhone, option);
  public modifyPhoneTwo = (option?: IHttpRequest) => send(API.modifyPhoneTwo, option);
  public getPreOrderInfo = (option?: IHttpRequest) => send(API.getPreOrderInfo, option);

  // 套餐价格
  public getMedicalPackagePrice = (option?: IHttpRequest) => send(API.getMedicalPackagePrice, option);

  // 公告
  public getNoticeBannerList = (option?: IHttpRequest) => send(API.getNoticeBannerList, option, "get");
  public getNoticeMarqueeList = (option?: IHttpRequest) => send(API.getNoticeMarqueeList, option, "get");
  public getNoticePopUpList = (option?: IHttpRequest) => send(API.getNoticePopUpList, option, "get");
  public noticeRead = (option?: IHttpRequest) => send(API.noticeRead, option);
  public noticePageList = (option?: IHttpRequest) => send(API.noticePageList, option);
  public getNotice = (option?: IHttpRequest) => send(API.getNotice, option, "get");

  //
  public getUnReadReportNum = (option?: IHttpRequest) => send(API.getUnReadReportNum, option, "get");
  public physicalReportList = (option?: IHttpRequest) => send(API.physicalReportList, option);
  public physicalReportDetail = (option?: IHttpRequest) => send(API.physicalReportDetail, option, "get");
  public uploadReport = (option?: IHttpRequest) => send(API.uploadReport, option);
  public proceedUploadReport = (option?: IHttpRequest) => send(API.proceedUploadReport, option);
  public downloadReport = (option?: IHttpRequest) => send(API.downloadReport, option, "get");
  public reportLogin = (option?: IHttpRequest) => send(API.reportLogin, option);

  // 企业隐私条款管理
  public checkPrivacyTerm = (option?: IHttpRequest) => send(API.checkPrivacyTerm, option, "get");
  public getNewestPrivacyTerm = (option?: IHttpRequest) => send(API.getNewestPrivacyTerm, option, "get");
  public getPrivacyTerm = (option?: IHttpRequest) => send(API.getPrivacyTerm, option, "get");
  public agreePrivacyTerm = (option?: IHttpRequest) => send(API.agreePrivacyTerm, option, "get");
  // 收货地址
  public addAddress = (option?: IHttpRequest) => send(API.addAddress, option);
  public deleteAddress = (option?: IHttpRequest) => send(API.deleteAddress, option, "delete");
  public updateAddress = (option?: IHttpRequest) => send(API.updateAddress, option, "put");
  public setAddressDefault = (option?: IHttpRequest) => send(API.setAddressDefault, option, "put");
  public getAddressDetail = (option?: IHttpRequest) => send(API.getAddressDetail, option, "get");
  public getAddressPageList = (option?: IHttpRequest) => send(API.getAddressPageList, option);
  public getAddressList = (option?: IHttpRequest) => send(API.getAddressList, option, "get");
  // 实物订单
  public createGoodsOrder = (option?: IHttpRequest) => send(API.createGoodsOrder, option);
  public getPreGoodsOrderInfo = (option?: IHttpRequest) => send(API.getPreGoodsOrderInfo, option, "get");
  public getGoodsOrderDetail = (option?: IHttpRequest) => send(API.getGoodsOrderDetail, option, "get");
  public cancelGoodsOrder = (option?: IHttpRequest) => send(API.cancelGoodsOrder, option, "put");
  public confirmGoodsOrder = (option?: IHttpRequest) => send(API.confirmGoodsOrder, option);
  public proceedpayGoodsOrder = (option?: IHttpRequest) => send(API.proceedpayGoodsOrder, option, "get");
  public confirmGoodsOrderInfo = (option?: IHttpRequest) => send(API.confirmGoodsOrderInfo, option);
  public modifyGoodsOrderAddress = (option?: IHttpRequest) => send(API.modifyGoodsOrderAddress, option, "put");
  public onRevokeGoods = (option?: IHttpRequest) => send(API.onRevokeGoods, option, "put");
  // 健康产品
  public getHealthProductDetail = (option?: IHttpRequest) => send(API.getHealthProductDetail, option, "get");
  public getHealthProductList = (option?: IHttpRequest) => send(API.getHealthProductList, option);
  // 医疗服务
  public getPreMedicalOrderInfo = (option?: IHttpRequest) => send(API.getPreMedicalOrderInfo, option, "get");
  public createMedicalOrder = (option?: IHttpRequest) => send(API.createMedicalOrder, option);
  public getMedicalOrderDetail = (option?: IHttpRequest) => send(API.getMedicalOrderDetail, option, "get");
  public getMedicalOrderSupportHospitals = (option?: IHttpRequest) => send(API.getMedicalOrderSupportHospitals, option);
  public appointMedicalOrder = (option?: IHttpRequest) => send(API.appointMedicalOrder, option);
  public getMedicalOrderSchedule = (option?: IHttpRequest) => send(API.getMedicalOrderSchedule, option, "get");
  public changeMedicalOrderSchedule = (option?: IHttpRequest) => send(API.changeMedicalOrderSchedule, option, "put");
  public refundMedicalOrder = (option?: IHttpRequest) => send(API.refundMedicalOrder, option);
  public cancelMedicalOrder = (option?: IHttpRequest) => send(API.cancelMedicalOrder, option, "put");
  public cancelAppointMedicalOrder = (option?: IHttpRequest) => send(API.cancelAppointMedicalOrder, option, "put");
  public proceedPayMedicalOrder = (option?: IHttpRequest) => send(API.proceedPayMedicalOrder, option, "get");
  public getPayPreByNo = (option?: IHttpRequest) => send(API.getPayPreByNo, option, "get");
  public toPay = (option?: IHttpRequest) => send(API.toPay, option);
  public submitOrderProductForm = (option?: IHttpRequest) => send(API.submitOrderProductForm, option);
  public getOrderProductForm = (option?: IHttpRequest) => send(API.getOrderProductForm, option, "get");
  public confirmOrder = (option?: IHttpRequest) => send(API.confirmOrder, option);

  // 健康短文
  public getHealthArticleList = (option?: IHttpRequest) => send(API.getHealthArticleList, option);
  public getHealthArticleDetail = (option?: IHttpRequest) => send(API.getHealthArticleDetail, option, "get");
  public getHealthArticlePageList = (option?: IHttpRequest) => send(API.getHealthArticlePageList, option);
  // 检查个人是否完善
  public checkIsPerfect = (option?: IHttpRequest) => send(API.checkIsPerfect, option, "get");

  // 体检预约验证
  public appointmentverification = (option?: IHttpRequest) => send(API.appointmentverification, option); // 体检预约验证

  // 自定义页面管理服务
  public getPageConfig = (option?: IHttpRequest) => send(API.getPageConfig, option, "get"); // 客户端获取企业页面配置
  public getPage = (option?: IHttpRequest) => send(API.getPage, option, "get"); // 体检预约验证

  //获取品牌列表
  public brandLogList = (option?: IHttpRequest) => send(API.brandLogList, option, "get"); // 获取品牌列表
  public addbrandLog = (option?: IHttpRequest) => send(API.addbrandLog, option); // 添加品牌

  // 获取解析列表
  public queryAnalyze = (option?: IHttpRequest) => send(API.queryAnalyze, option, "get"); // 获取解析列表
  public cancelReservation = (option?: IHttpRequest) => send(API.cancelReservation, option); // 取消预约

  public getAnalysisResults = (option?: IHttpRequest) => send(API.getAnalysisResults, option, "get"); // 获取ocr解析结果

  public initOCRAnalysis = (option?: IHttpRequest) => send(API.initOCRAnalysis, option, "get"); // 获取ocr解析结果
  public getStoreProduct = (option?: IHttpRequest) => send(API.getStoreProduct, option); // 获取店铺商品
  public getStorePackageBrandType = (option?: IHttpRequest) => send(API.getStorePackageBrandType, option); // 获取服务商品牌列表
  public getStoreProductType = (option?: IHttpRequest) => send(API.getStoreProductType, option, "get"); // 获取商品分类

  public url2base64 = (option?: IHttpRequest) => send(API.url2base64, option, "get"); // 通过图片链接获取base64
  public deleteFamily = (option?: IHttpRequest) => send(API.deleteFamily, option, "delete");
  public checkDeleteFamily = (option?: IHttpRequest) => send(API.checkDeleteFamily, option, "get");

  // 获取健康险详情
  public getHealthInsDetail = (option?: IHttpRequest) => send(API.getHealthInsDetail, option, "get"); // 获取健康险详情

  // 订单评价
  public getEvaluateData = (option?: IHttpRequest) => send(API.getOrderingEvaluate, option, "get"); // 客户端获取评价详情
  public evaluateBeforeAdd = (option?: IHttpRequest) => send(API.orderingEvaluateBefore, option); // 客户端提交订单评价前获取订单基本信息
  public evaluateAdd = (option?: IHttpRequest) => send(API.orderingEvaluateAdd, option); // 客户端提交订单评价

  public getEmployerAuth = (option?: IHttpRequest) => send(API.getEmployerAuth, option, "get"); // 客户端获取授权书实体类

  // 体检报告服务
  public sendQueryUnAuth = (option?: IHttpRequest) => send(API.sendQueryUnAuth, option); // 客户发送未授权报告验证码
  public queryUnAuth = (option?: IHttpRequest) => send(API.queryUnAuth, option); // 客户端查询未授权报告
  public authReport = (option?: IHttpRequest) => send(API.authReport, option); // 客户端授权报告
  public getApptNotice = (option?: IHttpRequest) => send(API.getApptNotice, option, "get"); // 获取预约须知

  public supportHospitalSchedules = (option?: IHttpRequest) => send(API.supportHospitalSchedules, option); // 获取机构排期

  // 权益
  public getRightsList = (option?: IHttpRequest) => send(API.getRightsList, option, "get"); // 获取权益商品列表
  public getRightsListByPost = (option?: IHttpRequest) => send(API.getRightsListByPost, option); // 获取指定权益商品列表
  public getRightsDetail = (option?: IHttpRequest) => send(API.getRightsDetail, option, "get"); // 获取权益商品详情
  public getRightsProductDetail = (option?: IHttpRequest) => send(API.getRightsProductDetail, option, "get"); // 获取权益商品内产品详情

  /**
   * rights
   * 权益订单接口服务
   */
  public clientList = (option?: IHttpRequest) => send(API.clientList, option); // 客户端获取订单列表数据
  public getClient = (option?: IHttpRequest) => send(API.getClient, option, "get"); // 客户端获取订单详情
  public clientCancel = (option?: IHttpRequest) => send(API.clientCancel, option, "put"); // 客户端取消订单
  public clientActive = (option?: IHttpRequest) => send(API.clientActive, option, "put"); // 获取标签详情
  public clientGetCard = (option?: IHttpRequest) => send(API.clientGetCard, option, "get"); // 客户端获取卡片信息
  public clientGetCardByMemberRightId = (option?: IHttpRequest) =>
    send(API.clientGetCardByMemberRightId, option, "get"); // 通过人员权益id获取卡片信息
  public getRightsPreInfo = (option?: IHttpRequest) => send(API.getRightsPreInfo, option, "get"); // 权益产品确认订单
  public rightsProceedPay = (option?: IHttpRequest) => send(API.rightsProceedPay, option, "get"); // 权益产品继续支付
  public createRightsOrder = (option?: IHttpRequest) => send(API.createRightsOrder, option); // 权益产品提交订单
  public getGroupProducts = (option?: IHttpRequest) => send(API.getGroupProducts, option, "get"); // 客户端获取权益产品组详情
  public getByRights = (option?: IHttpRequest) => send(API.getByRights, option); // 获取权益体检套餐详情
  public getScheduleByRights = (option?: IHttpRequest) => send(API.getScheduleByRights, option); // 获取权益体检套餐机构排期
  public getSupportHospitalsByRights = (option?: IHttpRequest) => send(API.getSupportHospitalsByRights, option); // 获取权益体检套餐支持机构
  public supportHospitalSchedulesByRights = (option?: IHttpRequest) =>
    send(API.supportHospitalSchedulesByRights, option); // 机构列表获取排期
  public getPreOrderInfoByRights = (option?: IHttpRequest) => send(API.getPreOrderInfoByRights, option); // 客户端权益内体检订单预信息（权益内体检订单下单前的信息汇总）
  public addByRights = (option?: IHttpRequest) => send(API.addByRights, option); // 客户端权益内体检套餐下单

  // 先买后约订单
  public pendingAdd = (option?: IHttpRequest) => send(API.pendingAdd, option); // 先买后约订单-下单
  public pendingAppointment = (option?: IHttpRequest) => send(API.pendingAppointment, option, "put"); // 先买后约订单-预约体检
  public pendingCancel = (option?: IHttpRequest) => send(API.pendingCancel, option, "put"); // 先买后约订单-取消订单
  public pendingProceedPay = (option?: IHttpRequest) => send(API.pendingProceedPay, option, "get"); // 先买后约订单-继续支付
  public pendingDetail = (option?: IHttpRequest) => send(API.pendingDetail, option, "get"); // 先买后约订单-订单详情
  public pendingGetPreInfo = (option?: IHttpRequest) => send(API.pendingGetPreInfo, option, "get"); // 先买后约订单-订单预信息（下单前的信息汇总）
  public getHospitalInfo = (option?: IHttpRequest) => send(API.getHospitalInfo, option, "get"); // 客户端-根据机构id获取机构信息
  public pendingCheckNotPayOrder = (option?: IHttpRequest) => send(API.pendingCheckNotPayOrder, option); // 先买后约订单-检查是否存在待付款订单

  // 获取品牌列表
  public getSupplierBrandList = (option?: IHttpRequest) => send(API.getSupplierBrandList, option); // 获取品牌列表

  // 客户端权益卡兑换
  public rightsExchanged = (option?: IHttpRequest) => send(API.rightsExchanged, option); // 客户端权益卡兑换

  // 优惠券
  public getCouponDetail = (option?: IHttpRequest) => send(API.getCouponDetail, option); // 领取中心详情
  public couponReceive = (option?: IHttpRequest) => send(API.couponReceive, option, "get"); // 领取优惠券
  public getUseTargetKind = (option?: IHttpRequest) => send(API.getUseTargetKind, option); // 领取中心tabs数据
  public myGetUseTargetKind = (option?: IHttpRequest) => send(API.myGetUseTargetKind, option); // 我的-领取中心tabs数据
  public getCouponList = (option?: IHttpRequest) => send(API.getCouponList, option); // 客户端我的优惠券列表
  public couponMyGet = (option?: IHttpRequest) => send(API.couponMyGet, option); // 客户端我的优惠券详情
  public couponSuitable = (option?: IHttpRequest) => send(API.couponSuitable, option); // 客户端获取商品可用的优惠券
  public getCouponListPage = (option?: IHttpRequest) => send(API.getCouponListPage, option); // 客户端优惠券列表数据-首页优惠券

  // 首页推广
  public getStorePopup = (option?: IHttpRequest) => send(API.getStorePopup, option, "get"); // 客户端优惠券列表数据-首页优惠券
  public getCityArea = (option?: IHttpRequest) => send(API.getCityArea, option, "get");
  public storeProductPageList = (option?: IHttpRequest) => send(API.storeProductPageList, option); // 通过机构拿套餐
  public hospitalPageList = (option?: IHttpRequest) => send(API.hospitalPageList, option); // 机构列表
}
